import {
  toastrErrorAlert,
  toastrSuccessAlert,
} from "components/Common/AlertToastr";
import { CommonButton } from "components/Common/ButtonCommon";
import HeaderCreateItem from "components/Common/HeaderCreateItem";
import { CommonText } from "components/Common/TextCommon";
import InputField from "components/form-control/InputField";
import VVSTable from "components/form-control/VVSTable";
import useGetFormSchema from "custom-hook/useGetFormSchema";
import { language_vn } from "helpers/language_vn";
import { GET_REFERRAL, GET_REFFERAL_BONUS } from "helpers/url_helper";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { Card, Col, Container, Row } from "reactstrap";
import httpService from "services/httpService";
import * as yup from "yup";

export default function NewRefferalBonus() {
  const [referralDetail, setReferralDetail] = useState({});
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    getRefferalBonusDetail();
  }, [id]);

  const {
    handleSubmit,
    formState: { errors },
    ...rest
  } = useForm({
    mode: "onBlur",
  });

  const { getValues } = rest;
  const { renderForm, getAddress } = useGetFormSchema(
    "RefferalBonus",
    yup,
    rest,
    errors
  );

  const getRefferalBonusDetail = async () => {
    if (!id) return;

    const res = await httpService.get(
      `${GET_REFFERAL_BONUS}/${id}?include=["employee", "customer", "isApprovedBy"]`
    );

    if (!res) {
      history.replace("/refferal-bonus");
      toastrErrorAlert("Refferal Bonus not found!");
      return;
    }

    const params = {
      params: {
        where: {
          referralBonus: {
            objectId: res.objectId,
            className: "RefferalBonus",
            __type: "Pointer",
          },
        },
      },
    };

    const resReferral = await httpService.get(`${GET_REFERRAL}`, params);

    const sumSales = resReferral.results.reduce((sum, item) => {
      const total = (sum += Number(item.totalSale));
      return total;
    }, 0);

    const { reset } = rest;
    setReferralDetail(res);
    reset({
      ...res,
      createdAt: moment(res?.createdAt).format("YYYY-MM-DD"),
      employee: res?.employee
        ? {
            text: res.employee?.fullName,
            objectId: res.employee.objectId,
            className: "Employee",
            __type: "Pointer",
          }
        : { text: "" },
      customer: res?.customer
        ? {
            text: res.customer?.fullName,
            objectId: res.customer.objectId,
            className: "Customer",
            __type: "Pointer",
          }
        : { text: "" },
      isApprovedBy: res?.isApprovedBy
        ? {
            text: res.isApprovedBy?.fullName,
            objectId: res.isApprovedBy.objectId,
            className: "Employee",
            __type: "Pointer",
          }
        : { text: "" },

      totalInvited: resReferral.results.length || 0,
      totalSales: sumSales || 0,
    });
  };

  const onSubmit = async values => {
    const { setValue } = rest;
    if (id) {
      try {
        const res = await httpService.put(`${GET_REFFERAL_BONUS}/${id}`, {
          isApproved: true,
        });
        if (res.updatedAt) {
          setValue("isApproved", true);
          toastrSuccessAlert("Duyệt hoa hồng thành công!!");
          return;
        }
      } catch (error) {
        toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!!");
      }
      return;
    }
  };

  return (
    <div className="page-content">
      <form onSubmit={handleSubmit(onSubmit)}>
        <HeaderCreateItem title={"Chi tiết hoa hồng"}>
          {!getValues("isApproved") && (
            <CommonButton level={0} type="submit">
              Duyệt hoa hồng
            </CommonButton>
          )}
        </HeaderCreateItem>
        <Container fluid>
          {renderForm([])}
          <Card body>
            <Row>
              <Col>
                <InputField
                  label="Tổng số người đã mời"
                  name="totalInvited"
                  readOnly
                  {...rest}
                />
              </Col>
              <Col>
                <InputField
                  label="Tổng doanh số"
                  name="totalSales"
                  {...rest}
                  readOnly
                />
              </Col>
            </Row>
          </Card>
          <Card body>
            <CommonText level={1} className="m-0">
              {language_vn.referral}
            </CommonText>
            <VVSTable
              name="Referral"
              disableAdd
              disableDelete
              disableSearch
              whereQuery={{
                referralBonus: {
                  objectId: referralDetail.objectId,
                  className: "RefferalBonus",
                  __type: "Pointer",
                },
              }}
              className="m-0 p-0 shadow-none"
            />
          </Card>
        </Container>
      </form>
    </div>
  );
}
